<template>
    <div class="customer-notice-container">
        <div class="notice-header">
            <h1 class="notice-title">《下单指引》</h1>
        </div>
        
        <div class="tab-container">
            <el-tabs v-model="activeTab">
                <el-tab-pane label="DE SEND下单指引" name="de">
                    <div class="pdf-container">
                        <div class="pdf-header">
                            <div class="pdf-icon">
                                <img :src="$ossUrl+'images/customerNotice/pdf.svg'" alt="PDF">
                            </div>
                            <div class="pdf-title" @click="downloadPdf('de')">DE SEND下单指引.pdf</div>
                        </div>
                    </div>
                    <div class="notice-content">
                        <div v-for="(item, index) in deGuideList" :key="index" class="notice-item">
                            <div class="item-icon">
                                <img :src="item.icon" alt="icon">
                            </div>
                            <div class="item-content">
                                <div class="item-title">{{ item.title }}</div>
                                <div class="item-desc" v-html="formatDesc(item.desc)"></div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                
                <el-tab-pane label="UK SEND下单指引" name="uk">
                    <div class="pdf-container">
                        <div class="pdf-header">
                            <div class="pdf-icon">
                                <img :src="$ossUrl+'images/customerNotice/pdf.svg'" alt="PDF">
                            </div>
                            <div class="pdf-title" @click="downloadPdf('uk')">UK SEND下单指引.pdf</div>
                        </div>
                    </div>
                    <div class="notice-content">
                        <div v-for="(item, index) in ukGuideList" :key="index" class="notice-item">
                            <div class="item-icon">
                                <img :src="item.icon" alt="icon">
                            </div>
                            <div class="item-content">
                                <div class="item-title">{{ item.title }}</div>
                                <div class="item-desc" v-html="formatDesc(item.desc)"></div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                
                <el-tab-pane label="US SEND下单指引" name="us">
                    <div class="pdf-container">
                        <div class="pdf-header">
                            <div class="pdf-icon">
                                <img :src="$ossUrl+'images/customerNotice/pdf.svg'" alt="PDF">
                            </div>
                            <div class="pdf-title" @click="downloadPdf('us')">US SEND下单指引.pdf</div>
                        </div>
                    </div>
                    <div class="notice-content">
                        <div v-for="(item, index) in usGuideList" :key="index" class="notice-item">
                            <div class="item-icon">
                                <img :src="item.icon" alt="icon">
                            </div>
                            <div class="item-content">
                                <div class="item-title">{{ item.title }}</div>
                                <div class="item-desc" v-html="formatDesc(item.desc)"></div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
https://public-aaf-shenzhen-file.oss-cn-beijing.aliyuncs.com/webStatic/newCompany/images/customerNotice/baoxianyusuopei.svg
<script>
export default {
    name: 'CustomerNotice',
    data() {
        return {
            activeTab: 'de',
            deGuideList: [
                {
                    icon: this.$ossUrl + 'images/customerNotice/xiangmai.svg',
                    title: '箱唛',
                    desc: '亚马逊后台创建好货件之后点击打印标签，会自动生成 FBA 标签和货代运输标签，请和箱号一一对应贴于货件上。如客户未贴标需要我司仓库代贴标，国内收费1元/张。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/baozhuangyaoqiu.svg',
                    title: '包装要求',
                    desc: '请务必使用出口标准纸箱包装货物，太软的纸箱会在运输途中变形，破裂，导致货物丢失。货箱外箱包装需使用透明胶带，不得缠过多的胶带、绑扎带，钉子、蛇皮袋，黄色胶带拉伸膜等过度包装。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/tihuoyurucang.svg',
                    title: '提货与入仓',
                    desc: '如要求我司上门提货，需给到详细的提货仓库地址和有效联系方式，提货费参考SEND报价表。如客户自送到美通仓库，需要按要求张贴入仓单，不收取提货费。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/kuneifuwu.svg',
                    title: '库内服务',
                    desc: '入仓后我司测量尺寸，目前我司采用机器测量和人工测量两种方式结合，如客户对我司货物数据有异议可以安排复测。如果货物已经出仓的则无法复测，以首次测量数据为准。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/pinmingyaoqiu.svg',
                    title: '品名要求',
                    desc: '品名要求：请务必如实申报品名<br>目前，我司仓库不接收的货物品名如下（包括但不限于以下品名）：<br>A. 不接受移动电源和纯电池，<br>B. 不接受仿牌、违禁物品，<br>C. 不接受食品、药品、烟酒类产品，茶叶、咖啡属于食品类<br>D. 电子类、玩具类等CE产品需有效的CE标识<br><span style="color: red;">温馨提示：无CE证书我司正常收发货，海关查验因货物本身原因或者客户自己的清关税号问题导致扣货，我司不负责</span>'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/tigongziliao.svg',
                    title: '按箱单发票模板提供资料',
                    desc: '<span style="color: red;">A. 渠道、报关方式、客户VAT、3个关键信息，必须准确<br>B. 申报不符(如品名、数量不符)，所产生的任何问题，我司不承担任何责任<br>C. 货值申报单位：欧元<br>D.新客户需提供POA</span>'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/diancichuhuoyaoqiu.svg',
                    title: '带电池产品出货要求',
                    desc: '带电未申报，如被查到，罚款￥5000，并且将承担产生的退货费、机场分箱费、国外理货操作费等。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/paisong.svg',
                    title: '派送',
                    desc: '德国SEND空运尾端快递派/卡派随机安排，可提供签收单。快递派送的货物以网上签收为派送成功，卡派的以电子签收证明为派送成功。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/baoxianyusuopei.svg',
                    title: '保险与索赔',
                    desc: '未买保险的货物在运输过程中如货物丢失，按照RMB40/KG赔偿且不退运费。购买上架险的货物，如果发生货损或商品丢失,客户需要提供相关文件,协助我司向保险公司索赔,最终以保险公司实际赔偿金额为准。'
                }
            ],
            ukGuideList: [
                {
                    icon: this.$ossUrl + 'images/customerNotice/xiangmai.svg',
                    title: '箱唛',
                    desc: '亚马逊后台创建好货件之后点击打印标签，会自动生成 FBA 标签和货代运输标签，请和箱号一一对应贴于货件上。如客户未贴标需要我司仓库代贴标，国内收费1元/张。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/baozhuangyaoqiu.svg',
                    title: '包装要求',
                    desc: '请务必使用出口标准纸箱包装货物，太软的纸箱会在运输途中变形，破裂，导致货物丢失。货箱外箱包装需使用透明胶带，不得缠过多的胶带、绑扎带，钉子、蛇皮袋，黄色胶带拉伸膜等过度包装。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/tihuoyurucang.svg',
                    title: '提货与入仓',
                    desc: '如要求我司上门提货，需给到详细的提货仓库地址和有效联系方式，提货费参考SEND报价表。如客户自送到美通仓库，需要按要求张贴入仓单，不收取提货费。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/kuneifuwu.svg',
                    title: '库内服务',
                    desc: '入仓后我司测量尺寸，目前我司采用机器测量和人工测量两种方式结合，如客户对我司货物数据有异议可以安排复测。如果货物已经出仓的则无法复测，以首次测量数据为准。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/pinmingyaoqiu.svg',
                    title: '品名要求',
                    desc: '品名要求：请务必如实申报品名<br>目前，我司仓库不接收的货物品名如下（包括但不限于以下品名）：<br>A. 不接受移动电源和纯电池，<br>B. 不接受仿牌、违禁物品，<br>C. 不接受玩具枪及其配件等武器类产品，不接医疗产品、婴幼儿产品<br>D. 不接受食品、药品、烟酒类产品，茶叶、咖啡属于食品类<br>E. 电子类、玩具类等需要UKCA认证产品需提供有效的UKCA认证以及有效的安全检测报告<br><span style="color: red;">温馨提示：无UKCA证书我司正常收发货，海关查验因货物本身原因或者客户自己的清关税号问题导致扣货，我司不负责</span>'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/tigongziliao.svg',
                    title: '按箱单发票模板提供资料',
                    desc: '<span style="color: red;">A. 渠道、报关方式、客户VAT、3个关键信息，必须准确<br>B. 申报不符(如品名、数量不符)，所产生的任何问题，我司不承担任何责任<br>C. 货值申报单位：英镑GBP<br>D.新客户需提供POA</span>'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/diancichuhuoyaoqiu.svg',
                    title: '带电池产品出货要求',
                    desc: '带电未申报，如被查到，罚款￥5000，并且将承担产生的退货费、机场分箱费、国外理货操作费等。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/paisong.svg',
                    title: '派送',
                    desc: '英国SEND空运尾端快递派/卡派随机安排，可提供签收单。快递派送的货物以网上签收为派送成功，卡派的以电子签收证明为派送成功。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/baoxianyusuopei.svg',
                    title: '保险与索赔',
                    desc: '未买保险的货物在运输过程中如货物丢失，按照RMB40/KG赔偿且不退运费。购买上架险的货物，如果发生货损或商品丢失,客户需要提供相关文件,协助我司向保险公司索赔,最终以保险公司实际赔偿金额为准。'
                }
            ],
            usGuideList: [
                {
                    icon: this.$ossUrl + 'images/customerNotice/xiangmai.svg',
                    title: '箱唛',
                    desc: '亚马逊后台创建好货件之后点击打印标签，会自动生成 FBA 标签和货代运输标签，请和箱号一一对应贴于货件上。如客户未贴标需要我司仓库代贴标，国内收费1元/张。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/baozhuangyaoqiu.svg',
                    title: '包装要求',
                    desc: '出货需每箱贴"MADE IN CHINA"的标签，产品上也需要贴MADE IN CHINA，如产品未贴有中国制造的标签导致货物被扣，我司概不负责。请务必使用出口标准纸箱包装货物，太软的纸箱会在运输途中变形，破裂，导致货物丢失。货箱外箱包装需使用透明胶带，不得缠过多的胶带、绑扎带，钉子、蛇皮袋，黄色胶带拉伸膜等过度包装。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/tihuoyurucang.svg',
                    title: '提货与入仓',
                    desc: '如要求我司上门提货，需给到详细的提货仓库地址和有效联系方式，提货费参考SEND报价表。如客户自送到美通仓库，需要按要求张贴入仓单，不收取提货费。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/kuneifuwu.svg',
                    title: '库内服务',
                    desc: '入仓后我司测量尺寸，目前我司采用机器测量和人工测量两种方式结合，如客户对我司货物数据有异议可以安排复测。如果货物已经出仓的则无法复测，以首次测量数据为准。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/pinmingyaoqiu.svg',
                    title: '品名要求',
                    desc: '品名要求：请务必如实申报品名<br>目前，我司仓库不接收的货物品名如下（包括但不限于以下品名）：<br>A. 枪支弹药、毒品、白色粉末、爆炸易燃危险品、毒性物质、化学腐蚀品、侵权仿牌产品、书籍、古董、货币、石墨，外箱贴有九类危险标识的货物<br>B. 未有品牌授权的手机、电子产品（不限于以上列举）等产品；反倾销、涉及政治、宗教、侵犯知识产权、美国禁止进口货物、国家禁止出口及航空公司禁运物品<br>C. 婴幼儿产品、原木制品、电子烟、医疗器械、食品、药品、化妆品（包括光疗仪、酒精棉）、干燥剂、汽车轮胎产品<br><span style="color: red;">D. 不具备以下认证或未贴相关标签等原因导致海关查验扣关。（如蓝牙、HDMI、FDA认证和注册、FCC、Lacey Act、DOT（不限于以上列举）等产品</span><br>E. 移动电源、管制刀具、捆绑件、安全锤、手推车、钢钉、登山杖、折叠型金属桌椅、激光类产品<br>F. 国家管制的稀有金属：钆、钇、铈、钕、铒、镱、铂、钋、镭、锕、钍、铀、钚、锔、锎、锿、锂、铼、镓、铟、锗、钛、锆、铪、钽、钨、钼、铼、碲铋、铟、锑、钐、铽、镝、镨、钪、铍、铌、钍、镍、锰等<br>G. 其他限制入仓货物：不属于以上危险品目录范围的货物以及其它外包装上带有易燃、 易爆、易腐蚀标示的货物等，出货前请于SEND客服确认<br><span style="color: red;">温馨提示：务必提供真实齐全详细产品申报信息（品名、产品数量、品牌、型号等），如我司仓库检查不符，罚款RMB2000/票起；带电、带磁、带液体粉末等产品瞒报，如被机场安检查验，罚款RMB2000/票起；以上原因导致海关查验或查验不符，罚款RMB5000/票起，其他额外费用实报实销 ；并且发件人将承担产生的退货费、机场分箱费、国外理货操作费、空运操作费等 因冲货产生的其他费用实报实销</span>'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/tigongziliao.svg',
                    title: '美国客户使用自己bone清关需要签订POA，POA需要以下文件',
                    desc: '<span>A. Importer basic information (Recommend head letter document) Company name, address, telephone number, website, contact person name<br>B. Formal Company Registration Document<br>C. Formal Employer Identification Number Letter<br>D.Signatory Photo ID<br>清关后我们需在美国按照Customs Form 7501的金额支付税金后方可派送</span>'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/diancichuhuoyaoqiu.svg',
                    title: '带电池产品出货要求',
                    desc: '带电容量不能超3000mah 20WH。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/paisong.svg',
                    title: '派送',
                    desc: '美国SEND空运未指定快递派送，默认UPS和FEDEX随机安排，快递派送的货物以网上签收为派送成功。'
                },
                {
                    icon: this.$ossUrl + 'images/customerNotice/baoxianyusuopei.svg',
                    title: '保险与索赔',
                    desc: '未买保险的货物在运输过程中如货物丢失，按照RMB40/KG赔偿且不退运费。购买上架险的货物，如果发生货损或商品丢失,客户需要提供相关文件,协助我司向保险公司索赔,最终以保险公司实际赔偿金额为准。'
                }
            ]
        }
    },
    methods: {
        async downloadPdf(type) {
            const pdfUrls = {
                de: 'https://public-aaf-shenzhen-file.oss-cn-beijing.aliyuncs.com/aaf1.0/send/DE%20SEND%E4%B8%8B%E5%8D%95%E6%8C%87%E5%BC%95.pdf',
                uk: 'https://public-aaf-shenzhen-file.oss-cn-beijing.aliyuncs.com/aaf1.0/send/UK%20SEND%E4%B8%8B%E5%8D%95%E6%8C%87%E5%BC%95.pdf',
                us: 'https://public-aaf-shenzhen-file.oss-cn-beijing.aliyuncs.com/aaf1.0/send/US%20SEND%E4%B8%8B%E5%8D%95%E6%8C%87%E5%BC%95.pdf'
            };

            if (!pdfUrls[type]) {
                this.$message.error('PDF文件链接不存在');
                return;
            }

            try {
                const response = await fetch(pdfUrls[type]);
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${type.toUpperCase()}_SEND下单指引.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (e) {
                this.$message.error('下载失败，请重试');
            }
        },
        formatDesc(desc) {
            // 处理描述中的标红部分
            // 如果需要动态标红某些关键词，可以在这里添加逻辑
            // 例如：return desc.replace(/重要提示/g, '<span class="red-text">重要提示</span>');
            // 目前我们已经在数据中使用HTML标签进行标红，所以直接返回即可
            return desc;
        }
    }
}
</script>

<style scoped>
.customer-notice-container {
    background-color: #f8f8f8;
    max-width: 100%;
    margin: 0 auto;
}


/* 响应式样式 */
@media screen and (max-width: 768px) {
    .customer-notice-container {
        padding: 10px;
    }
    
    .notice-title {
        font-size: 20px;
    }
    
    .item-title {
        font-size: 16px;
    }
    
    .item-desc {
        font-size: 13px;
    }
    
    .pdf-container {
        padding: 10px;
        flex-wrap: wrap;
    }
    
    .pdf-header {
        margin-bottom: 5px;
    }
    
    .pdf-title {
        font-size: 14px;
        text-decoration: underline;
        cursor: pointer;
    }
    
    .notice-item {
        flex-direction: column;
    }
    
    .item-icon {
        margin-bottom: 10px;
        margin-right: 0;
        justify-content: flex-start;
    }
    
    .item-content {
        width: 100%;
    }
    
    ::v-deep .el-tabs__item {
        padding: 0 10px;
        font-size: 14px;
    }
}

.notice-header {
  background-image: url('https://public-aaf-shenzhen-file.oss-cn-beijing.aliyuncs.com/webStatic/newCompany/images/customerNotice/bg.png');
  background-size: cover;
  background-position: center;
  height: 130px;
  padding: 15px 0;
  color: white;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notice-title {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
    letter-spacing: 1px;
}

.tab-container {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pdf-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px;
    border-radius: 4px;
    margin-bottom: 25px;
}

.pdf-header {
    display: flex;
    align-items: center;
}

.pdf-icon img {
    width: 24px;
    height: 24px;
    margin-right: 12px;
}

.pdf-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    text-decoration: underline;
    cursor: pointer;
}

.pdf-download {
    cursor: pointer;
    color: #409EFF;
    font-size: 20px;
    transition: all 0.3s;
}

.pdf-download:hover {
    transform: scale(1.1);
    color: #66b1ff;
}

.notice-content {
    margin-top: 25px;
}

.notice-item {
    display: flex;
    margin-bottom: 25px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eaecef;
}

.notice-item:last-child {
    border-bottom: none;
}

.item-icon {
    flex: 0 0 40px;
    margin-right: 15px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}

.item-icon img {
    width: 30px;
    height: 30px;
    object-fit: contain;
}

.item-content {
    flex: 1;
}

.item-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 12px;
    color: #333;
}

.item-desc {
    font-size: 14px;
    line-height: 1.8;
    color: #666;
    text-align: justify;
}

.red-text {
    color: #f56c6c;
    font-weight: bold;
}

/* 自定义el-tabs样式 */
::v-deep .el-tabs__header {
  margin-bottom: 25px;
  border-bottom: 1px solid #e4e7ed;
  width: max-content;
  margin: 0 auto;
  max-width: 100%;
}

::v-deep .el-tabs__item {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: #606266;
    padding: 0 20px;
}
::v-deep .el-tabs__item.is-active {
    color: #409EFF;
    font-weight: bold;
}

::v-deep .el-tabs__active-bar {
    height: 3px;
    background-color: #409EFF;
}
</style>